import { useEffect } from 'react';

/* ────────────────────────────────────────────────────────────
 * useCommandPaletteHotkey — Cmd/Ctrl+K global trigger.
 *
 * Mount once near the app root alongside <CommandPalette>:
 *
 *   const [open, setOpen] = useState(false);
 *   useCommandPaletteHotkey(() => setOpen((o) => !o));
 *   <CommandPalette open={open} onClose={() => setOpen(false)} ... />
 * ──────────────────────────────────────────────────────────── */

const useCommandPaletteHotkey = (onToggle) => {
  useEffect(() => {
    const handler = (e) => {
      const isMac = typeof navigator !== 'undefined' && /Mac/i.test(navigator.platform);
      const accel = isMac ? e.metaKey : e.ctrlKey;
      if (accel && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        onToggle();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onToggle]);
};

export default useCommandPaletteHotkey;
